module.exports = __webpack_public_path__ + "static/media/debin.3b7e2065.svg";